<template>
  <v-card class="mx-auto" :disabled="ldg">
    <v-card-title>
      <v-row dense>
        <v-col cols="12" md="10">
          <span class="text-h6 ml-1" v-text="$route.meta.title" />
        </v-col>
        <v-col cols="12" md="2" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                color="info"
                @click.prevent="faqs_dlg = true"
                :loading="faqs_ldg"
                :disabled="faqs.length == 0"
              >
                <v-icon> mdi-help </v-icon>
              </v-btn>
            </template>
            Ayuda
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="teal"
                :loading="dwn_ldg"
                :disabled="items.length == 0"
                @click.prevent="downloadXlsx"
              >
                <v-icon> mdi-table-arrow-down </v-icon>
              </v-btn>
            </template>
            Descargar tabla XLSX
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="3">
          <v-select
            label="Filtro"
            v-model="filter"
            :items="filters"
            item-value="id"
            :item-text="(v) => v.name"
            dense
            :disabled="items.length > 0"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Aseguradora(s)"
            v-model="insurance_ids"
            :items="insurances"
            item-value="id"
            :item-text="(v) => v.name"
            :loading="insurances_ldg"
            dense
            multiple
            :disabled="items.length != 0"
          />
        </v-col>
        <v-col cols="12" md="3">
          <DatePicker
            :label="'F. registro | Inicio'"
            :model.sync="start"
            :disabled="items.length > 0"
          />
        </v-col>
        <v-col cols="12" md="3">
          <DatePicker
            :label="'Final'"
            :model.sync="end"
            :disabled="items.length > 0"
          />
        </v-col>
        <v-col v-if="items.length == 0" cols="12">
          <v-btn
            block
            small
            color="success"
            @click.prevent="getItems"
            :loading="ldg"
          >
            Buscar
            <v-icon right> mdi-magnify </v-icon>
          </v-btn>
        </v-col>
        <v-col v-else cols="12">
          <v-btn
            block
            small
            color=""
            @click.prevent="
              totals = null;
              items = [];
            "
          >
            Cambiar parametros
            <v-icon right> mdi-refresh </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="items.length > 0">
        <v-col cols="12" md="3">
          <ViewData label="Monto" :value="numberFormat(totals.amount)" />
        </v-col>
        <v-col cols="12" md="3">
          <ViewData label="Registros" :value="items.length" />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            label="Buscar..."
            v-model="items_srch"
            append-icon="mdi-magnify"
            single-line
            hide-details
            dense
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :items="items"
            :headers="items_hdrs"
            :search="items_srch"
            :loading="ldg"
            :items-per-page="15"
            dense
          >
            <template v-slot:item.key="{ item }">
              <b v-text="item.key + 1" />
            </template>
            <template v-slot:item.folio="{ item }">
              {{ item.folio }}
              <br />
              <v-tooltip v-if="login.permissions.rhas.read" left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="pink"
                    x-small
                    icon
                    :to="{
                      name: 'admission_request.detalle',
                      params: { id: item.id },
                    }"
                  >
                    <v-icon small> mdi-eye </v-icon>
                  </v-btn>
                </template>
                Detalle
              </v-tooltip>
            </template>
            <template v-slot:item.rha_letter.is_express="{ item }">
              <v-icon x-small :color="item.rha_letter.is_express ? 'info' : ''">
                mdi-circle
              </v-icon>
            </template>
            <template v-slot:item.full_name="{ item }">
              <span :class="item.insured_id ? '' : 'orange--text'">
                {{ item.full_name }}
              </span>
            </template>
            <template v-slot:item.rha_letter.authorized_amount="{ item }">
              {{ numberFormat(item.rha_letter.authorized_amount) }}
            </template>

            <template v-slot:item.rha_amount.used_amount="{ item }">
              {{
                item.rha_amount
                  ? numberFormat(item.rha_amount.used_amount)
                  : "-"
              }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";
import {
  URL_API,
  headersToken,
  dateTimeNow,
  base64ToArrayBuffer,
  dateTimeToFile,
  msgAlert,
  numberFormat,
} from "../../control";
import FaqDlg from "../../components/FaqDlg.vue";
import DatePicker from "../../components/DatePicker.vue";
import ViewData from "../../components/ViewData.vue";

export default {
  components: {
    FaqDlg,
    DatePicker,
    ViewData,
  },
  data() {
    return {
      login: this.$store.getters.getLogin,
      filter: 0,
      filters: [],
      insurance_ids: [],
      insurances: [],
      insurances_ldg: true,
      ldg: false,
      totals: null,
      items: [],
      items_srch: "",
      items_hdrs: [],
      start: null,
      end: null,
      dwn_ldg: false,
      numberFormat: numberFormat,
      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
    };
  },
  methods: {
    getItems() {
      this.ldg = true;
      this.totals = null;
      this.items = [];

      Axios.get(
        URL_API +
          "/rhas/pending_payments" +
          "?filter=" +
          this.filter +
          "&insurance_ids=" +
          this.insurance_ids +
          "&start=" +
          this.start +
          "&end=" +
          this.end,
        headersToken(this.login.token)
      ).then((rsp) => {
        if (rsp.data.data.items.length > 0) {
          this.totals = rsp.data.data.totals;
          this.items = rsp.data.data.items;
        } else {
          this.$swal.fire(
            msgAlert("warning", "Sin resultados para la busqueda")
          );
        }

        this.ldg = false;
      });
    },
    downloadXlsx() {
      this.dwn_ldg = true;

      Axios.post(
        URL_API + "/rhas/pending_payments/xlsx",
        {
          items: this.items,
        },
        headersToken(this.login.token)
      ).then((rsp) => {
        if (rsp.data.success) {
          this.fileDownload(rsp.data.data, "xlsx", "I_PEND_COBRO");
          this.dwn_ldg = false;
        } else {
          this.dwn_ldg = false;
          this.$swal.fire(msgAlert("error", "Error al generar archixo XLSX"));
        }
      });
    },
    fileDownload(base64, ext, name) {
      const blob = new Blob([base64ToArrayBuffer(base64)], {
        type: "application/" + ext,
      });
      let downloadLink = document.createElement("a");
      downloadLink.setAttribute("target", "_blank");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = "SM_" + name + "_" + dateTimeToFile() + "." + ext;
      downloadLink.click();
    },
  },
  mounted() {
    Axios.get(
      URL_API + "/faqs/faq_interfaces/" + this.$route.meta.title,
      headersToken(this.login.token)
    ).then((resp) => {
      this.faqs = resp.data.data;
      this.faqs_ldg = false;
    });

    Axios.get(URL_API + "/insurances", headersToken(this.login.token)).then(
      (resp) => {
        this.insurances = resp.data.data;
        this.insurances_ldg = false;
      }
    );

    this.filters = [
      {
        id: 0,
        name: "TODOS",
      },
    ];

    this.items_hdrs = [
      {
        text: "#",
        value: "key",
        filterable: false,
        sortable: false,
      },
      {
        text: "Folio",
        value: "folio",
      },
      {
        text: "F. registro",
        value: "created_at",
      },
      {
        text: "ID SM",
        value: "enrollment",
      },
      {
        text: "Asegurado",
        value: "full_name",
      },
      {
        text: "Contratante",
        value: "contractor",
      },
      {
        text: "Oficina",
        value: "office_address",
      },
      {
        text: "Proveedor",
        value: "provider.trade_name",
      },
      {
        text: "Aseguradora",
        value: "insurance.name",
      },
      {
        text: "Éxpres",
        value: "rha_letter.is_express",
      },
      {
        text: "Terminado",
        value: "discharge",
      },
      {
        text: "Monto carta",
        value: "rha_letter.authorized_amount",
      },
      {
        text: "Monto gastado",
        value: "rha_amount.used_amount",
      },
    ];

    this.start = dateTimeNow().substring(0, 8) + "01";
    this.end = dateTimeNow().substring(0, 10);
  },
};
</script>
